'use client';

import { Session } from 'next-auth';
import {
    HeroSection,
    PricingSection,
    Footer
} from './ui';

// Simple client component for landing page only (non-logged-in users)
export default function AihumanitClient({
    initialSession,
    searchParams
}: {
    initialSession: Session | null;
    searchParams?: { content?: string; mode?: string };
}) {
    return (
        <div className="min-h-screen">
            <HeroSection initialSession={initialSession} searchParams={searchParams} />
            <PricingSection />
            <Footer />
        </div>
    );
}